/* Bundled to public/js/main.js by gulp (esbuild). The ?v= cache-buster
   is a hash of the bundle, so any byte change here mints a new asset URL. */
(function () {
  var SocialMediaView = {
    initialize: function ($el) {
      this.$el = $el;
      this.href = window.location.href;
      this.description = $('meta[property="og:description"]').attr('content');
      this.media = $('meta[property="og:image"]').attr('content');

      var self = this;
      this.$el.on('click', '> div', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.share(e);
      });
    },
    facebook: function () {
      window.open(
        encodeURI('http://www.facebook.com/sharer/sharer.php?u=' + this.href),
        '_blank',
        'status = 1, height = 420, width = 550'
      );
    },
    twitter: function () {
      // console.log('twitter');
      window.open(
        encodeURI('http://twitter.com/share?&url=' + this.href),
        '_blank',
        'status = 1, height = 420, width = 550'
      );
    },
    linkedin: function () {
      // console.log('linkedin');
      window.open(
        encodeURI(
          'https://www.linkedin.com/sharing/share-offsite/?url=' + this.href
        ),
        '_blank',
        'status = 1, height = 420, width = 550'
      );
    },
    email: function () {
      location.href = 'mailto:?&body=' + window.location.href;
    },
    share: function (e) {
      var type = $(e.currentTarget).attr('class');
      if (this[type]) {
        this[type]();
      }
      return false;
    }
  };

  $(function () {
    $('#example-list .column li, .has-poll-id').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var href = $(e.currentTarget).data('href');
      if (href) {
        window.open(href, '_blank').focus();
        return;
      }

      var pollId = $(e.currentTarget).data('poll-id');
      if (pollId) {
        window.Zigpoll.pollId = pollId;
        window.Zigpoll.onload = function () {
          window.Zigpoll.open();
        };
        window.Zigpoll.refresh();
      }
    });

    if ($('#share')[0]) {
      SocialMediaView.initialize($('#share'));
    }

    $('.mobile-menu-toggle').on('click', function (e) {
      $('.mobile-menu-toggle, #mobile-nav').toggleClass('active');
      $('body > .page-container').toggleClass('lock');
    });

    /* Widening the window past the mobile breakpoint hides the open menu and
       its close button, but left the page scroll-locked with no way out. Close
       it on the way across. Matches $mobile in scss/variables.scss. */
    var desktopQuery = window.matchMedia('(min-width: 800px)');

    function closeMobileNavOnDesktop() {
      if (desktopQuery.matches) {
        $('.mobile-menu-toggle, #mobile-nav').removeClass('active');
        $('body > .page-container').removeClass('lock');
      }
    }

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', closeMobileNavOnDesktop);
    } else {
      desktopQuery.addListener(closeMobileNavOnDesktop);
    }

    /* Header dropdowns open on hover in CSS. This covers what hover can't:
       touch screens, where the first tap on a trigger opens its panel
       (Customers and Resources are links, and navigate on the second tap),
       and panels that would hang off the edge of a narrow window. */
    var $navItems = $('#header .nav-item.has-menu');
    var canHover = window.matchMedia('(hover: hover)').matches;

    function placeNavMenu($item) {
      var menu = $item.children('.nav-menu')[0];
      menu.style.setProperty('--menu-shift', '0px');

      var rect = menu.getBoundingClientRect();
      var gutter = 10;
      var shift = 0;

      if (rect.left < gutter) {
        shift = gutter - rect.left;
      } else if (rect.right > window.innerWidth - gutter) {
        shift = window.innerWidth - gutter - rect.right;
      }

      // html is zoomed to 0.8 between 800 and 950px (html-head.ejs), so the
      // on-screen overflow has to be converted back to CSS pixels.
      var zoom = rect.width / menu.offsetWidth || 1;
      menu.style.setProperty('--menu-shift', shift / zoom + 'px');
    }

    function closeNavMenus($except) {
      $navItems.not($except).removeClass('open');
      $navItems
        .not($except)
        .children('button.nav-trigger')
        .attr('aria-expanded', 'false');
    }

    $navItems.on('mouseenter focusin', function () {
      placeNavMenu($(this));
    });

    $navItems.on('mouseleave', function () {
      if (canHover) {
        closeNavMenus();
      }
    });

    $navItems.children('.nav-trigger').on('click', function (e) {
      var $item = $(this).parent();
      var isLink = this.tagName === 'A';

      if (isLink && (canHover || $item.hasClass('open'))) {
        return;
      }

      e.preventDefault();
      closeNavMenus($item);
      placeNavMenu($item);
      $item.toggleClass('open');
      $(this).filter('button').attr('aria-expanded', $item.hasClass('open'));
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest('#header .nav-item').length) {
        closeNavMenus();
      }
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        closeNavMenus();
      }
    });

    var isTabVisible = true;
    // Listen for page visibility changes
    document.addEventListener('visibilitychange', () => {
      isTabVisible = !document.hidden;
    });

    function typeWriter($target, newText, baseDelay) {
      // Cancel any existing animation on this element
      clearTimeout($target.data('typingTimeout'));

      let currentText = $target.text();
      let i = currentText.length;

      function setTimeout_(fn, delay) {
        var id = setTimeout(fn, delay);
        $target.data('typingTimeout', id);
        return id;
      }

      function randomDelay(base) {
        return baseDelay + Math.floor(Math.random() * base);
      }

      function erase() {
        if (!isTabVisible) {
          // Pause and retry shortly when tab visible again
          setTimeout_(erase, 200);
          return;
        }
        if (i > 0) {
          $target.text(currentText.substring(0, i - 1));
          i--;
          setTimeout_(erase, randomDelay(20));
        } else {
          type(0);
        }
      }

      function type(j) {
        if (!isTabVisible) {
          setTimeout_(function () {
            type(j);
          }, 200);
          return;
        }
        if (j < newText.length) {
          $target.text($target.text() + newText.charAt(j));
          setTimeout_(function () {
            type(j + 1);
          }, randomDelay(70));
        }
      }

      erase();
    }

    function createCyclingRandomPicker(array) {
      let pool = [];

      function shuffle(arr) {
        // Fisher–Yates shuffle
        for (let i = arr.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
      }

      return function getNext() {
        if (pool.length === 0) {
          pool = shuffle(array.slice()); // make a new shuffled copy
        }
        return pool.pop(); // take from the end
      };
    }

    // Usage:
    $('.typewriter').each(function () {
      var $el = $(this);
      var headlines = $el.data('headlines') || '';
      headlines = headlines.split('|');

      const pickHeadline = createCyclingRandomPicker(headlines);

      typeWriter($el, pickHeadline(), 10);
      setInterval(function () {
        if (isTabVisible) {
          typeWriter($el, pickHeadline(), 10);
        }
      }, 1000 * 10);
    });

    const baseUrl = 'https://www.youtube.com/embed/J-zPr5qRSF0';
    $('.open-yt-video').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Add muted=1 to enable autoplay on mobile (video will be muted)
      const autoplayUrl = baseUrl + '?autoplay=1&rel=0';
      $('#youtube-frame').attr('src', autoplayUrl);
      $('#video-modal').show();
    });

    $('.close, #video-modal').on('click', function (e) {
      if (e.target !== this && !$(e.target).hasClass('close')) return;
      $('#youtube-frame').attr('src', ''); // Stop video
      $('#video-modal').hide();
    });

    if ($('#post.c')[0]) {
      // Smooth scroll for server-rendered ToC links
      $('#toc .item a').on('click', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var target = $(href);
        if (target.length) {
          window.scrollTo({
            top: target.offset().top - 100,
            behavior: 'smooth'
          });
          history.replaceState(null, '', href);
        }
      });
    }

    // $("#mobile-nav a").on('click', function (e) {
    //   window.location.reload();
    // });

    require('./ascii-waves');
    require('./scroll-reveal');
    require('./composites');
    require('./synthetic-stream');

    $.fn.isInViewport = function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    var hasPlayedVideo = false;
    function handleVideo($el, isPassiveInteraction) {
      $el = $el.find('.video-wrapper');
      $('.video-wrapper').each(function (idx) {
        $(this).find('video')[0].pause();
        $(this).removeClass('active');
      });
      hasPlayedVideo = true;
      $el.find('video')[0].play();
      $el.addClass('active');

      // var hasTouched = $el.hasClass('has-touched');

      // if (isPassiveInteraction && hasTouched) { return }

      // if (!isPassiveInteraction) {
      //   $el.addClass('has-touched');
      // }

      // var isActive = $el.hasClass('active');
      // var video = $el.find('video')[0];

      // if (isActive) {
      //   video.pause();
      //   $el.removeClass('active');
      // } else {
      //   video.play();
      //   $el.addClass('active');
      // }
    }

    // $('.video-component').on('click', function (e) {
    //   handleVideo($(e.currentTarget), false);
    // });
    // $('.feature-wrapper').on('mouseenter', function (e) {
    //   handleVideo($(e.currentTarget), true);
    // });

    function playClosestVideoToCenter() {
      var closestVideoIdx = null;
      var minDistance = Infinity;
      var $vids = $('.video-wrapper');

      $vids.each(function (idx) {
        var $el = $(this);

        if ($el.isInViewport()) {
          // Viewport center
          var viewportMiddleY = $(window).scrollTop() + $(window).height() / 2;
          var viewportMiddleX = $(window).scrollLeft() + $(window).width() / 2;

          // Element center
          var elementMiddleY = $el.offset().top + $el.outerHeight() / 2;
          var elementMiddleX = $el.offset().left + $el.outerWidth() / 2;

          // Distance from element center to viewport center
          var deltaY = elementMiddleY - viewportMiddleY;
          var deltaX = elementMiddleX - viewportMiddleX;
          var distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY); // Euclidean distance

          if (distance < minDistance) {
            minDistance = distance;
            closestVideoIdx = idx;
          }
        }
      });

      if (closestVideoIdx !== null) {
        $vids.each(function (idx) {
          var video = $(this).find('video')[0];
          if (!video) return;

          if (idx === closestVideoIdx) {
            video.play();
            $(this).addClass('active');
            $(this).closest('.feature').addClass('active');
          } else {
            video.pause();
            $(this).removeClass('active');
            $(this).closest('.feature').removeClass('active');
          }
        });
      }
    }

    // $('.video-component').on('mouseleave', function (e) {
    //   handleVideo($(e.currentTarget), true);
    // });

    $(window).on('resize scroll', _.debounce(playClosestVideoToCenter));
    $('.features').on('scroll', _.debounce(playClosestVideoToCenter));

    $(document).on('click', 'a', function (e) {
      if (!window.gtag) {
        return;
      }

      var href = $(e.currentTarget).attr('href') || '';
      if (href.indexOf('app.zigpoll.com') !== -1) {
        window.gtag('event', 'sign_up', {
          event_category: 'zigpoll',
          event_label: 'sign_up'
        });
        fbq('track', 'Sign Up CTA', {});
        fbq('track', 'AddToWishlist');
      }
      if (href.indexOf('apps.shopify.com') !== -1) {
        window.gtag('event', 'shopify_app', {
          event_category: 'zigpoll',
          event_label: 'shopify_app'
        });
      }
      return;
    });

    function adjustHeader(e) {
      if (window.scrollY > 10) {
        $('#header').addClass('active');
      } else {
        $('#header').removeClass('active');
      }
    }
    $(window).on('scroll', adjustHeader);
    $(window).on('load', adjustHeader);

    var rand = function () {
      return Math.random().toString(36).substr(2);
    };

    var token = function () {
      return rand() + rand();
    };

    function getUserToken() {
      if (window.localStorage.getItem('userToken')) {
        return window.localStorage.getItem('userToken');
      }
      window.localStorage.setItem('userToken', token());
      return window.localStorage.getItem('userToken');
    }

    var client = algoliasearch(
      'AFPNOH9KVA',
      '2fe2c063e7b94799eba9053c0d1014e5',
      {
        headers: {
          'X-Algolia-UserToken': getUserToken()
        }
      }
    );
    var index = client.initIndex('zigpoll_search');

    function performSearch(val) {
      return index
        .search(val, { clickAnalytics: true })
        .then(function (data) {
          var hits = data.hits;
          var query = data.query;

          if (query === window.searchQuery) {
            window.searchResults = hits;
            window.queryID = data.queryID;
          }

          renderSearchResults();
        })
        .catch((err) => {
          console.log(err);
        });
    }

    function renderSearchResults() {
      if (window.searchResults === undefined) {
        $('#search-modal').removeClass('show-results');
      } else {
        $('#search-modal').addClass('show-results');
      }

      var results = window.searchResults || [];
      var $results = $('#search-modal .results');
      $results.scrollTop(0);
      $results.empty();
      results.slice(0, 20).forEach(function (result, idx) {
        var $result = $('<a class="result" href="' + result.objectID + '">');
        var $content = $('<div class="result-content">');

        $result.on('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          aa('clickedObjectIDsAfterSearch', {
            index: 'zigpoll_search',
            eventName: 'Click item',
            queryID: window.queryID,
            objectIDs: [$(e.currentTarget).attr('href')],
            positions: [idx + 1]
          });

          window.location = $(e.currentTarget).attr('href');
        });

        $content.append('<div class="title">' + result.title + '</div>');
        $content.append(
          '<div class="description">' +
            result.description +
            '<i class="fas fa-external-link" /></div>'
        );

        $result.append(
          "<div class='image'><img src='" + result.image + "'/></div>"
        );
        $result.append($content);
        $results.append($result);
      });
    }

    $('.search-toggle').on('click', function () {
      $('#search-modal').addClass('active');
      $('#search-modal input').focus();
    });

    function hideSearch() {
      $('#search-modal').removeClass('active');
      setTimeout(function () {
        $('#search-modal input').val('').blur();
        window.searchResults = undefined;
        window.searchQuery = undefined;
        renderSearchResults();
      }, 250);
    }

    $('#search-modal input').on('keyup', function (e) {
      if (e.which === 27) {
        return hideSearch();
      }

      window.searchQuery = e.currentTarget.value;
      performSearch(window.searchQuery);
    });

    $('#search-modal .overlay').on('click', function (e) {
      hideSearch();
    });

    aa('init', {
      appId: 'AFPNOH9KVA',
      apiKey: '2fe2c063e7b94799eba9053c0d1014e5'
    });

    aa('setUserToken', getUserToken());

    //   $('.video-wrapper').each(function (idx) {
    //     var $el = $(this);
    //     var video = $el.find('video')[0];

    //     if ($el.isInViewport()) {
    //       if (hasPlayedVideo === false) {
    //         hasPlayedVideo = true;
    //         $el.addClass('active');
    //         video.play();
    //       }
    //     } else {
    //       video.pause();
    //     }
    //   });
    // });

    function nextSlide() {
      var $el = $(this);
      var $slides = $el.closest('.container').find('.slide');
      var activeIdx;

      $slides.each(function (idx) {
        if ($(this).hasClass('active')) {
          activeIdx = idx;
        }
      });

      var nextIdx = activeIdx + 1 < $slides.length ? activeIdx + 1 : 0;
      goto.bind(this)(nextIdx);
    }

    function prevSlide() {
      var $el = $(this);
      var $slides = $el.closest('.container').find('.slide');
      var activeIdx;

      $slides.each(function (idx) {
        if ($(this).hasClass('active')) {
          activeIdx = idx;
        }
      });

      var nextIdx = activeIdx - 1 < 0 ? $slides.length - 1 : activeIdx - 1;
      goto.bind(this)(nextIdx);
    }

    var sliderMax = 30;
    var sliderTick = 0;

    function goto(idx) {
      var $el = $(this);
      var $slides = $el.closest('.container').find('.slide');
      var $nav = $el.closest('.container').find('.navigation > div');

      $slides.removeClass('active');
      $($slides[idx]).addClass('active');

      $nav.removeClass('active');
      $($nav[idx]).addClass('active');

      sliderTick = 0;
      setStatusCircles(0);
    }

    $('#case-study-slider .next').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      nextSlide.call(this);
    });

    $('#case-study-slider .prev').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      prevSlide.call(this);
    });

    $('#case-study-slider .navigation > div').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var idx = $(this).index();
      var $slides = $(this).closest('.container').find('.slide');
      goto.bind(this)(idx);
    });

    var caseStudySliderInterval;
    goto.bind($('#case-study-slider .next')[0])(0);
    setCaseStudyTimer();

    function setStatusCircles(perc) {
      var RADIUS = 10;
      var CIRCUMFERENCE = 2 * Math.PI * RADIUS;

      var progress = perc;
      var dashOffset = CIRCUMFERENCE * (1 - progress);
      var strokeDashArray = CIRCUMFERENCE;

      var $el = $('#case-study-slider .progress-circle');

      $el.find('.value').attr('stroke-dashoffset', dashOffset);
      $el.find('.value').attr('stroke-dasharray', strokeDashArray);
    }

    function setCaseStudyTimer() {
      clearInterval(caseStudySliderInterval);

      return (caseStudySliderInterval = setInterval(function () {
        sliderTick = sliderTick + 1;
        perc = sliderTick / sliderMax;

        if (perc >= 1) {
          perc = 0;
          sliderTick = 0;
          nextSlide.bind($('#case-study-slider .next')[0])();
        }

        setStatusCircles(perc);
      }, 250));
    }

    // $("#case-study-slider").on('mouseenter', function (e) {
    //   e.preventDefault();
    //   e.stopPropagation();

    //   clearInterval(caseStudySliderInterval);
    // });

    // $("#case-study-slider").on('mouseleave', function (e) {
    //   e.preventDefault();
    //   e.stopPropagation();

    //   setCaseStudyTimer();
    // });

    $('#faq li.hidden').on('click', function (e) {
      $(e.currentTarget).toggleClass('active');
    });

    $('#pricing-toggle > div > div').on('click', function (e) {
      const $el = $(e.currentTarget);
      $el.siblings().removeClass('active');
      $el.addClass('active');

      const type = $(e.currentTarget).data('type');
      $el.parent().removeClass('annual monthly');
      $el.parent().addClass(type);

      $(
        '#pricing-plans .plans .price, .pricing-container .plans .price, .plans .billing-cadence, .toggle-pricing'
      ).each(function (idx) {
        const annualPrice = $(this).data('annual-price');
        const monthlyPrice = $(this).data('monthly-price');

        let price;
        if (type === 'annual') {
          price = annualPrice;
        } else {
          price = monthlyPrice;
        }

        /* first(): the slider card's price line has a second span (.permo, the
           "/mo" suffix the Free stop hides) -- only the leading price span
           belongs to the toggle. Every other .price/.billing-cadence has
           exactly one span, so this is behavior-preserving for them. */
        $(this).find('span').first().html(price);
      });
    });

    $('.toggle-pricing').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      $('#pricing-toggle > div > div').not('.active').trigger('click');
    });

    var $bottomBlur = $('#bottom-blur');
    if ($bottomBlur.length) {
      $(window).on('scroll resize', function () {
        var docHeight = $(document).height();
        var viewportBottom = $(window).scrollTop() + $(window).height();
        if (viewportBottom >= docHeight - 250) {
          $bottomBlur.css('display', 'none');
        } else {
          $bottomBlur.css('display', '');
        }
      });
    }
  });
})();

/* Promo timer */
// (function () {
//   var SECOND = 1000;
//   var MINUTE = 60 * SECOND;
//   var HOUR   = 60 * MINUTE;
//   var DAY    = 24 * HOUR;

//   function pad(n) {
//     return (n < 10 ? '0' : '') + n;
//   }

//   function formatDuration(ms) {
//     if (ms < 0) { ms = 0; }
//     var d = Math.floor(ms / DAY);    ms -= d * DAY;
//     var h = Math.floor(ms / HOUR);   ms -= h * HOUR;
//     var m = Math.floor(ms / MINUTE); ms -= m * MINUTE;
//     var s = Math.floor(ms / SECOND);
//     return d + "d " + pad(h) + "h:" + pad(m) + "m:" + pad(s) + "s";
//   }

//   function startRollingSevenDayCountdown(opts) {
//     opts = opts || {};
//     var el = opts.el || document.getElementById('timer');
//     var onTick = opts.onTick;

//     var targetTs = Date.now() + 7 * DAY;
//     var secondTimer = null;
//     var resetTimer  = null;

//     function scheduleReset() {
//       clearTimeout(resetTimer);
//       resetTimer = setTimeout(function () {
//         targetTs = Date.now() + 7 * DAY;
//         scheduleReset();
//       }, Math.floor(6.5 * DAY));
//     }

//     function tick() {
//       if (Date.now() >= targetTs) {
//         targetTs = Date.now() + 7 * DAY;
//         scheduleReset();
//       }

//       var remaining = targetTs - Date.now();
//       var text = formatDuration(remaining);
//       if (el) { el.textContent = text; }
//       if (typeof onTick === 'function') { onTick(remaining, targetTs); }
//       console.log(text);
//     }

//     scheduleReset();
//     tick();
//     clearInterval(secondTimer);
//     secondTimer = setInterval(tick, 1000);

//     return {
//       stop: function () {
//         clearInterval(secondTimer);
//         clearTimeout(resetTimer);
//       },
//       resetNow: function () {
//         targetTs = Date.now() + 7 * DAY;
//         scheduleReset();
//         tick();
//       },
//       getTarget: function () {
//         return new Date(targetTs);
//       }
//     };
//   }

//   // Example usage:
//   window.countdownController = startRollingSevenDayCountdown({
//     el: document.getElementById('timer')
//   });
// })();
